import { RenderKeyCombination, RenderKeyCombinationType } from "~/hotkeys";
import { EditorAction } from "./editorKeyMap";

export const EditorKeyCombination = RenderKeyCombination as RenderKeyCombinationType<EditorAction>;
